import { useLayoutEffect, useRef, type RefObject } from 'react'
import { Outlet } from 'react-router-dom'
import { useAccount } from '@/entities/session'
import { useAdminStopImpersonation } from '@/entities/admin'
import styles from './ClientShell.module.css'
import { observeElementHeight } from './observeElementHeight'

/** Все клиентские страницы, включая онбординг, получают одну полосу impersonation. */
export function ClientShell() {
  const { data: account } = useAccount()
  const active = Boolean(account?.impersonation)
  const shellRef = useRef<HTMLDivElement>(null)
  const bannerRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    const shell = shellRef.current
    const banner = bannerRef.current
    if (!active || !shell || !banner) return

    const stop = observeElementHeight(banner, (height) => {
      shell.style.setProperty('--client-banner-height', `${height}px`)
    })

    return () => {
      stop()
      shell.style.removeProperty('--client-banner-height')
    }
  }, [active])

  return (
    <div ref={shellRef} className={active ? styles.impersonating : styles.shell}>
      {account?.impersonation && <ImpersonationBanner bannerRef={bannerRef} />}
      <Outlet />
    </div>
  )
}

function ImpersonationBanner({ bannerRef }: { bannerRef: RefObject<HTMLDivElement | null> }) {
  const { data: account } = useAccount()
  const stop = useAdminStopImpersonation()
  const impersonation = account?.impersonation

  if (!impersonation) return null

  return (
    <div ref={bannerRef} className={styles.banner} role="status">
      <span className={styles.message}>
        Вы вошли как <strong>{impersonation.targetEmail}</strong> ({impersonation.companyName})
      </span>
      <span className={styles.separator}>—</span>
      <button
        type="button"
        className={styles.returnButton}
        onClick={() => stop.mutate()}
        disabled={stop.isPending}
      >
        {stop.isPending ? 'Возвращаемся…' : 'Вернуться в админку'}
      </button>
    </div>
  )
}
